import { render, staticRenderFns } from "./ImageZoomer.vue?vue&type=template&id=3644fb16"
import script from "./ImageZoomer.vue?vue&type=script&lang=js"
export * from "./ImageZoomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports